import { render, staticRenderFns } from "./TransactionSummaryBlock.vue?vue&type=template&id=46964d72&scoped=true"
import script from "./TransactionSummaryBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionSummaryBlock.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TransactionSummaryBlock.vue?vue&type=style&index=0&id=46964d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46964d72",
  null
  
)

export default component.exports